import { FieldTypeSelector } from '@monorepo/shared/componentsV2/fields/FieldTypeSelector';
import { usePrevious } from '@monorepo/shared/hooks/usePrevious';
import { FormTemplateFieldTypes } from 'mapistry-shared';
import React, { useEffect } from 'react';
import { useField, useForm } from 'react-final-form';
import { getFieldTypeDisplay } from '../getFieldTypeDisplay';
import { addableFormTemplateFieldTypes } from './addableFormTemplateFieldTypes';

const useResetFormOnFieldTypeChange = () => {
  const form = useForm();
  const {
    input: { value: fieldType },
  } = useField<FormTemplateFieldTypes>('type');
  const previousType = usePrevious(fieldType);

  useEffect(() => {
    if (previousType && fieldType && previousType !== fieldType) {
      // Reset the form when the field type changes, preventing artifacts from other
      // field types and allowing type-specific initial values to populate
      form.initialize({ type: fieldType });
    }
  }, [fieldType, form, previousType]);
};

export function SelectFieldTypeWizardPage() {
  useResetFormOnFieldTypeChange();

  return (
    <FieldTypeSelector<FormTemplateFieldTypes>
      availableFieldTypes={addableFormTemplateFieldTypes}
      getFieldTypeDisplay={getFieldTypeDisplay}
      rowCount={7}
    />
  );
}
